export default __webpack_public_path__ + "static/media/NG.adcb391d.svg";